import {
    GET_CART_ITEMS,
    ADD_PRODUCT_TO_CART,
    ADD_CART_ITEM,
    UPDATE_PRODUCT_TO_CART,
    UPDATE_CARD,
    UPDATE_BILLING,
    UPDATE_SHIPPING,
    COMPLETE_PURCHASE,
    UPDATE_PURCHASE_MESSAGE,
    REMOVE_CART_ITEM,
    UPDATE_PRODUCT_QUANTITY,
    ADD_TRANSACTION_ID

} from '../../Actions/EndUser/StoreActions';
export const reducer = (state = {
    cartItems: [],
    cartTotal: 0,
    creditCard: {},
    shippingInfo: {},
    billingInfo: {},
    transactionId: 135,
    message: ''
}, action) => {
    switch (action.type) {
        case GET_CART_ITEMS:
            return {
                ...state,
                cartItems: action.cartItems,
                cartTotal: action.cartTotal,
                fullCart: action.cartItems,
                creditCard: {}
            };
        case ADD_PRODUCT_TO_CART:
            return {
                ...state,
                cartItems: action.cartItems.cartViewModel,
                cartTotal: action.cartItems.cartViewModel.length,
                fullCart: action.cartItems,
                creditCard: {}
            };
        case ADD_CART_ITEM:
                return {
                    ...state,
                    cartItems: action.cartItems,
                    cartTotal: action.cartTotal,
                    //fullCart: action.cartItems,
                    creditCard: {}
            };
        case REMOVE_CART_ITEM:
            return {
                ...state,
                cartItems: action.cartItems,
                cartTotal: action.cartTotal,
                creditCard: {}
            };
        case UPDATE_PRODUCT_QUANTITY:
            return {
                ...state,
                cartItems: action.cartItems,
                cartTotal: action.cartTotal,
                creditCard: {}
            };
        case UPDATE_CARD:
            return {
                ...state,
                creditCard: action.creditCard
            };
        case UPDATE_BILLING:
            return {
                ...state,
                billingInfo: action.billingInfo
            };
        case UPDATE_SHIPPING:
            return {
                ...state,
                shippingInfo: action.shippingInfo
            };
        case COMPLETE_PURCHASE:
            return {
                ...state,
                response: action.response,
                message: action.message,
                showMessage: true
            };
        case UPDATE_PURCHASE_MESSAGE:
            return {
                ...state,
                message: action.message,
                showMessage: false
            };
        case ADD_TRANSACTION_ID:
            return {
                ...state,
                transactionId: action.transactionId
            };
        default:
            return state;
    }
}